import { objectToCamelCase } from '../utils'

import OrganizationAPI from './api'

const DEFAULT_DARK_BRAND_COLOR = '2e63b3'
const DEFAULT_LIGHT_BRAND_COLOR = 'cce2f5'

export default class Organization {
  static api = OrganizationAPI.create(Organization)

  constructor(json) {
    Object.assign(this, { ...json })
    this.darkBrandColor = this.darkBrandColor || DEFAULT_DARK_BRAND_COLOR
    this.lightBrandColor = this.lightBrandColor || DEFAULT_LIGHT_BRAND_COLOR
    this.grantLimitDuration = this.formatGrantLimitDuration(
      this.grantLimitDuration,
      this.rollingGrantDuration,
    )
  }

  // constructor({
  //   id = '',
  //   name = '',
  //   subdomain = '',
  //   url = '',
  //   supportEmail = '',
  //   logo = '',
  //   darkBrandColor = '',
  //   lightBrandColor = '',
  //   isReadyForOnboarding = null,
  //   isReferralOrganization = null,
  //   grantLimit = null,
  //   grantLimitDuration = '',
  //   rollingGrantDuration = '',
  //   grantCountLimit = null,
  //   homepageCopy = '',
  //   additionalResourcesCopy = '',
  //   contributionCopy = '',
  //   hardshipDefinitionCopy = '',
  //   uniqueIdHelpCopy = '',
  //   allowsPayrollRequests = null,
  //   customVariables = null,
  //   startingFundBalance = null,
  //   payrollEmail = '',
  //   springFourEnabled = null,
  //   springFourCode = '',
  //   additionalResources = '',
  //   stripeCredentials = null,
  //   expenseCategories = [],
  //   donationsEnabled = null,
  //   expenseDocumentationEnabled = null,
  //   eventDocumentationEnabled = null,
  //   grantRequestAmountEnabled = null,
  //   enableLanguagePref = null,
  //   organizationMessage = {},
  //   isFinancialHealthSurveyEnabled = true,
  //   subOrganizations = [],
  // } = {}) {
  //   Object.assign(this, {
  //     id,
  //     name,
  //     subdomain,
  //     url,
  //     supportEmail,
  //     logo,
  //     darkBrandColor: darkBrandColor || DEFAULT_DARK_BRAND_COLOR,
  //     lightBrandColor: lightBrandColor || DEFAULT_LIGHT_BRAND_COLOR,
  //     isReadyForOnboarding,
  //     isReferralOrganization,
  //     grantLimit,
  //     grantLimitDuration: this.formatGrantLimitDuration(grantLimitDuration, rollingGrantDuration),
  //     grantCountLimit,
  //     rollingGrantDuration,
  //     homepageCopy = '',
  //     additionalResourcesCopy = '',
  //     contributionCopy = '',
  //     hardshipDefinitionCopy = '',
  //     uniqueIdHelpCopy = '',
  //     allowsPayrollRequests,
  //     customVariables,
  //     startingFundBalance,
  //     payrollEmail,
  //     springFourEnabled,
  //     springFourCode,
  //     additionalResources,
  //     stripeCredentials,
  //     expenseCategories: expenseCategories.map(category => ExpenseCategory.create(category)),
  //     donationsEnabled,
  //     expenseDocumentationEnabled,
  //     eventDocumentationEnabled,
  //     grantRequestAmountEnabled,
  //     enableLanguagePref,
  //     isFinancialHealthSurveyEnabled,
  //     organizationMessage:
  //       organizationMessage &&
  //       Object.keys(organizationMessage).length &&
  //       OrganizationMessage.create(organizationMessage),
  //     subOrganizations,
  //   })
  // }

  static create(opts) {
    return new Organization(opts)
  }

  static fromAPI(json) {
    return new Organization(objectToCamelCase(json))
  }

  formatGrantLimitDuration(duration, rollingGrantDuration) {
    const lookup = {
      CALENDAR_YEAR: 'Calendar Year',
      LIFETIME: 'Lifetime',
      ROLLING_X_YEARS: `Rolling ${rollingGrantDuration} Years`,
    }
    return lookup[duration]
  }
}
